export enum OfferStatus {
	ForSale = 0,
	NotForSale = 1,
	NonPublic = 2
}
